const auth = JSON.parse(sessionStorage.getItem("authUser"));
const accessToken = () => {
    return auth?.data?.token || ""
}
export default accessToken
